export const REQUEST_SERVICE_LEVEL_PRODUCTS_DATA = 'REQUEST_SERVICE_LEVEL_PRODUCTS_DATA';
export const RECEIVE_SERVICE_LEVEL_PRODUCTS_DATA = 'RECEIVE_SERVICE_LEVEL_PRODUCTS_DATA';

export const receiveServiceLevelProductsData = (payload) => ({
  type: RECEIVE_SERVICE_LEVEL_PRODUCTS_DATA,
  payload: payload
});




// WEBPACK FOOTER //
// ./src/actions/serviceLevelProductsActions.js